import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';
import css from './Price.module.scss';

interface Props {
  className?: string;
  price: number;
  isMonthly?: boolean;
}

const Price = (props: Props) => {
  const intl = useIntl();
  return (
    <span className={classNames(css.Price, props.className)}>
      {props.isMonthly && (
        <span className={css.Price__Montyly}>
          {intl.formatMessage({ id: 'merchants.common.price.monthly' })}
        </span>
      )}
      <span className={css.Price__Emphasis}>
        {intl.formatNumber(props.price)}
      </span>
      {intl.formatMessage({ id: 'merchants.common.price.unit' })}
    </span>
  );
};

export default Price;
